<template>
  <fragment>
    <img v-if="!asLoggedIn" src="/assets/images/sidenav.jpg" alt="Sidenav">
    <ul v-else class="sidenav-menu">
      <router-link
        :to="{ name: 'dashboard' }"
        exact
        class="sidenav-menu-item"
        tag="li"
        v-if="isAdmin"
      >
        <a :style="currentBackground">
          <icon class="icon" width="19" height="19" type="dashboard"/>
          <span>{{ $t('pages.dashboard.title') }}</span>
        </a>
      </router-link>
      <router-link
        :to="{ name: 'projects' }"
        exact
        class="sidenav-menu-item"
        tag="li"
        :class="[isProjectsActive ? 'exact-active' : '']"
      >
        <a :style="currentBackground">
          <icon class="icon" width="19" height="19" type="properties"/>
          <span>{{ $t('pages.projects.title') }}</span>
        </a>
      </router-link>
      <router-link
        :to="{ name: 'languages' }"
        exact
        class="sidenav-menu-item"
        tag="li"
        v-if="isAdmin"
      >
        <a :style="currentBackground">
          <icon class="icon" width="19" height="19" type="globe"/>
          <span>{{ $t('pages.languages.title') }}</span>
        </a>
      </router-link>
      <router-link
        :to="{ name: 'translators' }"
        exact
        class="sidenav-menu-item"
        tag="li"
        v-if="isAdmin"
      >
        <a :style="currentBackground">
          <icon class="icon" width="19" height="19" type="user"/>
          <span>{{ $t('pages.users.title') }}</span>
        </a>
      </router-link>

      <!-- deepltranslations SideNav Menu  -->
      <router-link
        :to="{ name: 'deepltranslations' }"
        exact
        class="sidenav-menu-item"
        tag="li"
        :class="[isDeepLActive ? 'exact-active' : '']"
        v-if="isAdmin"
      >
        <a :style="currentBackground">
          <icon class="icon" width="19" height="19" type="dashboard"/>
          <span>{{ $t('pages.deepltranslations.title') }}</span>
        </a>
      </router-link>

      <!-- Automated deepltranslations SideNav Menu  -->
      <router-link
        :to="{ name: 'automateddeepltranslations' }"
        exact
        class="sidenav-menu-item"
        tag="li"
        :class="[isAutomatedDeepLActive ? 'exact-active' : '']"
        v-if="isAdmin"
      >
        <a :style="currentBackground">
          <icon class="icon" width="19" height="19" type="dashboard"/>
          <span>{{ $t('pages.automateddeepltranslations.title') }}</span>
        </a>
      </router-link>

    </ul>
  </fragment>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'SideNav',
    data: () => ({
      menu: {
        products: false,
        property: false,
        distributors: false,
        manage: false,
        admin: false,
      },
    }),
    computed: {
      ...mapGetters('user', ['loggedIn', 'pageAllowed', 'userPageAllowed', 'currentColorFont', 'isAdmin', 'currentColorSchema']),
      ...mapGetters(['centered']),
      ...mapGetters('user', ['isAdmin', 'isDeveloper', 'isTranslator']),
      currentColor() {
        const {
          r, g, b, a,
        } = this.currentColorFont.rgba;
        return `color: rgba(${r}, ${g}, ${b}, ${a})`;
      },
      currentBackground() {
        const {
          r, g, b, a,
        } = this.currentColorSchema.rgba;
        return `color: rgba(${r}, ${g}, ${b}, ${a})`;
      },
      asLoggedIn() {
        return this.loggedIn && !this.centered;
      },
      isProductsActive() {
        return this.menu.products
          || ['rateplans', 'roomtypes', 'policies', 'photos', 'mealplans'].includes(this.$route.name);
      },
      isPropertyActive() {
        return this.menu.property
          || ['masterdata', 'contactpersons', 'facilities', 'nearby', 'booking', 'description'].includes(this.$route.name);
      },
      isDistributorsActive() {
        return this.menu.distributors || ['channels', 'channel', 'systems'].includes(this.$route.name);
      },
      isManageActive() {
        return this.menu.manage || ['group', 'hotels', 'users'].includes(this.$route.name);
      },
      isAdminActive() {
        const { name } = this.$route;
        return this.menu.admin || (name != null && name.indexOf('admin-') === 0);
      },
      isProjectsActive() {
        const { name } = this.$route;
        return this.menu.manage || (name != null && name.indexOf('projects-') === 0);
      },
      isDeepLActive() {
        const { name } = this.$route;
        return this.menu.manage || (name != null && name.indexOf('deepltranslations-') === 0);
      },
      isAutomatedDeepLActive() {
        const { name } = this.$route;
        return this.menu.manage || (name != null && name.indexOf('automateddeepltranslations-') === 0);
      },
    },
    watch: {
      $route() {
        this.toggleMenu();
      },
    },
    methods: {
      toggleMenu(name = null) {
        Object.keys(this.menu).forEach((k) => {
          this.menu[k] = k === name ? !this.menu[k] : false;
        });
      },
    },
  };
</script>
